var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCottage250DpFfffffFill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-160v-377.92l-83.23 64-18.31-24.16L200-576v-100.92h30.77v76.46L480-790l381.54 292.15-18.31 23.93-83.23-64V-160H200Zm30.77-30.77h198.46v-190.77h101.54v190.77h198.46v-370.08L480-751.15l-249.23 190.3v370.08ZM200-729.23q0-34.46 22.15-58.77 22.14-24.31 62.47-24.31 28.19 0 41.01-15.38 12.83-15.39 12.83-36.93h30.77q0 34.24-21.73 58.66-21.73 24.42-62.88 24.42-27.7 0-40.77 15.14-13.08 15.13-13.08 37.17H200Zm30.77 538.46H729.23 230.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCottage250DpFfffffFill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/cottage_250dp_FFFFFF_FILL0_wght200_GRAD0_opsz48.8a2d03c4786f5c8f8ea05df65271ff31.svg";
export { ForwardRef as ReactComponent };